module.exports = __webpack_public_path__ + "img/ben_thumb.8182420e.jpg";